module.exports = __webpack_public_path__ + "static/energy_private_7-95d49b203b318afc36f06e58264e6280.jpg";